/** @type {Record<string, import("./types.js").GuideRouteMeta>} */
export const guideRoutesEn = {
  "how": {
    "title": "How it works | Plaatplan",
    "description": "From standard sheet and subprojects to work plan: how to plan cutting in Plaatplan, step by step."
  },
  "werkplanExport": {
    "title": "Print work plan or save as PDF | Plaatplan",
    "description": "Open the work plan from the planner, configure under Prepare, review the Shop order and save as PDF for the hardware store or cutting service."
  },
  "cutSimulator": {
    "title": "Review cut sequence | Plaatplan",
    "description": "Review the cut sequence at home on desktop in the work plan. Understand numbered cut lines before you print or go to the cut shop."
  },
  "importExport": {
    "title": "Import and export projects | Plaatplan",
    "description": "Back up with a project file (.json), import on another device, and the difference from PDF or CSV export."
  }
};
